

































































import "@/assets/css/split.css";
import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import Moment from "moment-timezone";
import DeleteSourceData from './deletewaring.vue';
import checkAuth from "@/lib/Common/checkauth";

class PageUserRequest extends PageRequest {
    id: string;
    keyword: string;
    startTime: string;
    endTime: string;
    state: number;
    sortBy: string;
    desceding: boolean;
    tenantId: number;
}

@Component({
    components: { DeleteSourceData },
})
export default class DeviceWaring extends AbpBase {
    pagerequest: PageUserRequest = new PageUserRequest();
    deviceModalShow: boolean = false;
    treedata: any[] = [];
    treeDataList: any[] = [];
    tenantlist: any[] = [];
    splitnum: number = 0.15;
    deviceId: string = "";
    searchName: string = ""; //树形搜索名称
    spinShow: boolean = false;//加载状态
    deleModalShow: boolean = false;//删除窗口
    //检测按钮权限
    checkButtonAuth(tag: string) {
        return checkAuth.CheckButton(tag);
    }
    //批量删除
    async batchDelete() {
        this.deleModalShow = true;
    }
    //删除单条记录
    async deleteData(id: string) {
        this.pagerequest.id = id;
        this.spinShow = true;
        let res = await this.$store.dispatch({
            type: "devicewaring/delete",
            data: this.pagerequest,
        }).catch((err) => {
            this.spinShow = false;
            this.$Modal.error({
                title: this.L("Tips"),
                content: err,
            });
        });
        this.spinShow = false;
        this.$Modal.info({
            title: this.L("Tips"),
            content: res,
        });
        this.getSearch();
    }
    get list() {
        return this.$store.state.devicewaring.list;
    }
    get loading() {
        return this.$store.state.devicewaring.loading;
    }
    //搜索树形结构
    searchTree(value: any, treeList) {
        if (!value) {
            this.treedata = this.treeDataList;
            return;
        }
        const rebuildData = (value, treeList) => {
            let newarr = [];
            treeList.forEach((element) => {
                if (element.children && element.children.length) {
                    if (element.title != null && element.title.indexOf(value) > -1) {
                        element.expand = true;
                        newarr.push(element);
                    }
                    const ab = rebuildData(value, element.children);
                    const obj = {
                        ...element,
                        expand: true,
                        children: ab,
                    };
                    if (ab && ab.length) {
                        newarr.push(obj);
                    }
                } else {
                    if (element.title != null && element.title.indexOf(value) > -1) {
                        newarr.push(element);
                    }
                }
            });
            return newarr;
        };
        this.treedata = [];
        this.treedata = rebuildData(value, treeList);
    }
    async itemtree() {
        await this.$store
            .dispatch("tenant/getAllTenants")
            .then((val) => {
                this.treedata = val;
                this.treeDataList = val;
                if (val[0].children.length > 0) {
                    val[0].children.forEach((ele) => {
                        this.tenantlist.push({ id: ele.id, title: ele.title });
                    });
                }
            })
            .catch((err) => {
                //return null;
            });
    }
    pageChange(page: number) {
        this.$store.commit("devicewaring/setCurrentPage", page);
        this.getpage();
    }
    pagesizeChange(pagesize: number) {
        this.$store.commit("devicewaring/setPageSize", pagesize);
        this.getpage();
    }
    changeSort(key) {
        this.pagerequest.sortBy = key.key;
        if (key.order == "desc") {
            this.pagerequest.desceding = true;
        } else {
            this.pagerequest.desceding = false;
        }
        this.getpage();
    }
    getItemId() {
        let item = (this.$refs.tree as any).getSelectedNodes();
        if (item.length > 0) {
            this.pagerequest.tenantId = Number.parseInt(item[0].id);
        }
        this.$store.commit("devicewaring/setCurrentPage", 1);
        this.getpage();
    }
    getSearch() {
        this.$store.commit("devicewaring/setCurrentPage", 1);
        this.getpage();
    }
    async getpage() {
        this.pagerequest.maxResultCount = this.pageSize;
        this.pagerequest.skipCount = this.currentPage;
        await this.$store.dispatch({
            type: "devicewaring/getAll",
            data: this.pagerequest,
        });
    }
    changdate(val) {
        if (val.length > 1) {
            this.pagerequest.startTime = val[0];
            this.pagerequest.endTime = Moment(val[1], "YYYY-MM-DD HH:mm:ss")
                .format("YYYY-MM-DD HH:mm:ss");
        }
    }
    get pageSize() {
        return this.$store.state.devicewaring.pageSize;
    }
    get totalCount() {
        return this.$store.state.devicewaring.totalCount;
    }
    get currentPage() {
        return this.$store.state.devicewaring.currentPage;
    }
    columns = [
        {
            type: "index",
            width: 80,
            align: "left",
            title: this.L("IndexNo"),
        },
        {
            title: this.L("Imei"),
            key: "imei",
            resizable: true,
            sortable: true,
            width: 160,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.imei,
                        },
                    },
                    params.row.imei
                );
            },
        },
        {
            title: this.L("Data"),
            key: "data",
            resizable: true,
            width: 500,
            render: (h: any, params: any) => {
                return h("div", [
                    h(
                        "span",
                        {
                            style: {
                                display: "inline-block",
                                width: "93%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            },
                            domProps: {
                                title: params.row.data,
                            },
                        },
                        params.row.data
                    ),
                    h("Button",
                        {
                            props: {
                                type: "default",
                                size: "small",
                                icon: "md-copy",
                            },
                            on: {
                                click: async () => {
                                    this.handleCopy(params.row.data);
                                },
                            },
                        },)
                ])
            },
        },
        {
            title: this.L("Platform") + "Id",
            key: "ispDeviceId",
            width: 260,
            sortable: true,
            resizable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    {
                        style: {
                            display: "inline-block",
                            width: "100%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        },
                        domProps: {
                            title: params.row.ispDeviceId,
                        },
                    },
                    params.row.ispDeviceId
                );
            },
        },
        {
            title: this.L("GatherTime"),
            key: "createTime",
            width: 160,
            resizable: true,
            sortable: true,
            render: (h: any, params: any) => {
                return h(
                    "span",
                    params.row.createTime == null
                        ? ""
                        : Moment(params.row.createTime).format("YYYY-MM-DD HH:mm:ss")
                );
            },
        },
        {
            title: this.L("State"),
            key: "state",
            sortable: true,
            resizable: true,
            width: 130,
            render: (h: any, params: any) => {
                let str = this.L("Unknown");
                let id = params.row.state;
                if (id == 1) {
                    str = this.L("Normal");
                } else if (id == 2) {
                    str = this.L("NonExistent");
                }
                return h("span", str);
            },
        },
        {
            title: this.L("Actions"),
            key: "Actions",
            width: 90,
            fixed: "right",
            sortId: 49,
            render: (h: any, params: any) => {
                let del = this.checkButtonAuth('sourceDataDel');
                return h("div", [
                    del ? h(
                        "Button",
                        {
                            props: {
                                type: "error",
                                size: "small",
                            },
                            style: {
                                marginRight: "5px",
                            },
                            on: {
                                click: async () => {
                                    this.$Modal.confirm({
                                        title: this.L("Tips"),
                                        content: this.L("DeleteConfirm"),
                                        okText: this.L("Yes"),
                                        cancelText: this.L("No"),
                                        onOk: async () => {
                                            console.log(params.row)
                                            await this.deleteData(params.row.id)
                                        },
                                    });
                                },
                            },
                        },
                        this.L("Delete")
                    ) : '',
                ]);
            },
        },
    ];
    async created() {
        await this.itemtree();
        this.pagerequest.startTime = Moment()
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
        this.pagerequest.endTime = Moment()
            .format("YYYY-MM-DD HH:mm:ss");
        this.pagerequest.sortBy = "createTime";
        this.pagerequest.desceding = true;
        this.getpage();
    }
    handleCopy(data: any) {
        const input = document.createElement('input');
        document.body.appendChild(input);
        input.setAttribute('value', data);
        input.select();
        if (document.execCommand('copy')) {
            document.execCommand('copy');
            document.body.removeChild(input);
            this.$Notice.success({ title: this.L('CopySuccess') });
        } else {
            this.$Notice.error({ title: this.L('CopyFaile') });
            document.body.removeChild(input);
        }
    }
    data() {
        return {
            datepicker: {
                shortcuts: [
                    {
                        text: this.L("OneWeek"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("OneMonth"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            return [start, end];
                        },
                    },
                    {
                        text: this.L("ThreeMonths"),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            return [start, end];
                        },
                    },
                ],
            },
            pageSizeOpts: [10, 20, 50, 100, 200],
        };
    }
}
